import { SurveyCreator } from 'survey-creator-react';
import { JsonObject } from 'survey-core';
import CustomWidget from 'vl-md/src/CustomSurvey/customWidgets/CustomWidget';

/** Renders a custom survey widget that is identical to the expression class */
const CustomizeSurveySummary = (surveyCreator?: SurveyCreator) => {
  const activatedByChangeHandler = () => {
    JsonObject.metaData.addClass('summary', [], null, 'expression');
  };

  const afterRenderHandler = (question, el) => {};
  const htmlTemplate = '<div data-testid="customized-summary-component"><div></div></div>';
  const widgetIconName = 'icon-expression';

  CustomWidget({
    htmlTemplate,
    name: 'summary',
    title: 'Summary',
    activatedByChangeHandler,
    afterRenderHandler,
    iconName: widgetIconName,
    surveyCreator
  });
};

export default CustomizeSurveySummary;
